export interface HeaderPattern {
  path: string;
  tabs?: HeaderPatternTabs[];
  title: string;
  subTitle?: string;
  icon?: string;
  description?: string;
  role?: string;
}

export interface HeaderPatternTabs {
  path: string;
  active: boolean;
  title: string;
  editId?: number;
  subTabs?: HeaderPatternTabs[];
}

export const moduleHeaderList: HeaderPattern[] = [
  {
    path: '/pages/kpi-dashboard',
    title: 'kpiDashboard',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/revenue-manager',
    title: 'revenueManager',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/settings',
    title: 'userManagement',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/user-permissions',
    title: 'userPermissions',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/booking-overview',
    title: 'bookingOverview',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/cluster-pricing-configuration',
    title: 'clusterPricing',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: '/pages/fx-rate',
    title: 'fxRate',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: 'login',
    title: 'login',
    icon: '',
    tabs: [],
    subTitle: ''
  },
  {
    path: 'page-not-found',
    title: 'pageNotFound',
    icon: '',
    tabs: [],
    subTitle: ''
  }
];

export const replaceModuleTab = ( module: string, tabPath: string, newTabPath: string, editId?: number ) => {
  moduleHeaderList.map( m => {
    if( m.path === module ) {
      m.tabs.map( t => {
        if( t.path === tabPath ) {
          t.path = newTabPath;
          t.title = newTabPath.split( '-' ).map( s => s.charAt( 0 ).toUpperCase() + s.slice( 1 ) ).join( ' ' );
          t.active = true;
          t.editId = editId;
        }
      } );
    }
  } );
};
